<template>
    <tr>
        <td>{{ order.order.id }}</td>
        <td>
            <div class="customer-info">
                <div><small><my-date :dateTime="order.order.createdAt" format="date" /></small></div>
                <div><small><my-date :dateTime="order.order.createdAt" format="time" /></small></div>
            </div>
        </td>
        <td>
            <div class="customer-info">
                <div class="email-truncate" :title="order.order.user.email">{{ order.order.user.email }}</div>
                <div v-if="order.shipName"><small>ship name: <strong>{{ order.shipName }}</strong></small></div>
            </div>
        </td>
        <td><order-items :items="order.order.orderItems" /></td>
        <td>
            <div class="customer-info">
                <div v-if="order.order.paymentMethod === 'agreement'">
                    <div><small>distributor: {{ order.agreement.distributorName }}</small></div>
                    <div><router-link :to="'/distributor2/agreements/' + order.agreement.agreementId"><small>agreement:
                                <span v-if="order.agreement.name">{{ order.agreement.name }} ({{ order.agreement.agreementId }})</span>
                                <span v-else>id: {{ order.agreement.agreementId }}</span></small></router-link>
                    </div>
                </div>
                <div v-else>{{ order.order.paymentMethod }}</div>
            </div>
        </td>
        <td class="text-end"><small>{{ formatPrice(order.order.priceTotal) }} {{ order.order.currency }}</small></td>
        <td class="text-center order-status-cell">
            <div class="order-status-cell__label">
                <span class="order-status-cell__text" v-html="displayStatus(order.order.status)"></span>
                <span v-if="hasYearSubscriptions" class="badge text-bg-warning long-sub-label">long subscription</span>
            </div>
            <div v-if="error" class="alert alert-warning mt-1" role="alert"
                style="width: 200px;line-height: 18px;font-size: 14px;">
                <p>{{ error }}</p>
                <button class="btn btn-sm btn-warning" @click="error = null">Ok</button>
            </div>
            <template v-else-if="order.order.status === 'owner_approved' || order.order.status === 'new'">
                <div
                    class="order-status-cell__actions"
                    style="border-top: 1px dotted #495057; padding-top: 0.35rem; margin: 0.25rem 0 0.2rem; width: 100%; box-sizing: border-box;"
                >
                    <button type="button" class="btn btn-outline-primary" @click="processOrder(order.order.id)"
                        :disabled="buttonPushed">Process</button>
                    <button type="button" class="btn btn-outline-secondary"
                        @click="cancelOrder(order.order.id)" :disabled="buttonPushed">Cancel</button>
                </div>
            </template>
        </td>
    </tr>
</template>

<script>
import myAxios from "@/services/myAxios";
import MyDate from '@/components/MyDate.vue';
import OrderItems from "./OrderItems.vue";
import { eventBus } from '@/main';

export default {
    components: { MyDate, OrderItems },
    props: {
        order: {}
    },
    data() {
        return {
            error: null,
            buttonPushed: false
        }
    },
    computed: {
        hasYearSubscriptions() {
            return this.order.order.orderItems.some(o => o.duration > 6);
        }
    },
    methods: {
        processOrder(orderId) {
            this.buttonPushed = true;
            myAxios.get("/api/agreement/process-order?orderId=" + orderId)
                .then(() => {
                    eventBus.$emit("refreshOrder", this.order.order.id)
                })
                .catch(err => {
                    this.error = err.response.data ?? err.message
                })
                .finally(() => {
                    this.buttonPushed = false;
                })
        },
        cancelOrder(orderId) {
            this.buttonPushed = true;
            myAxios.post("/api/agreement/cancel-order", { orderId })
                .then(() => {
                    eventBus.$emit("refreshOrder", this.order.order.id)
                })
                .catch(err => {
                    this.error = err.response.data ?? err.message
                })
                .finally(() => {
                    this.buttonPushed = false;
                })
        },
        displayStatus(status) {
            if (status === 'cancelled_by_distirbutor') {
                return 'cancelled by<br>distirbutor';
            }
            return status.split('_').join(' ');
        },
        formatPrice(price) {
            return Number(price).toLocaleString('fr-FR');
        }
    }
}
</script>

<style>
.email-truncate {
    max-width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

td.order-status-cell {
    padding: 0.4rem 0.5rem;
}

td.order-status-cell .order-status-cell__label {
    display: block;
    margin: 0;
    padding: 0;
    line-height: 1;
}

td.order-status-cell .order-status-cell__text {
    display: block;
    margin: 0;
    padding: 0.1rem 0;
    font-size: 0.875em;
    line-height: 1.15;
}

.long-sub-label {
    font-size: 10px;
    font-weight: 500;
    line-height: 1;
    padding: 0 0.4em;
    margin: 0;
}

td.order-status-cell > .order-status-cell__actions {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;
    box-sizing: border-box;
    width: 100%;
    margin: 0.25rem 0 0.2rem;
    padding-top: 0.35rem;
    border-top: 1px dotted #495057;
}

td.order-status-cell > .order-status-cell__actions .btn {
    font-size: 0.75rem;
    padding: 0.08rem 0.45rem;
    line-height: 1.1;
}
</style>